import loadable from "@loadable/component";
import StatusIcon from "../../../Icons/StatusIcon";

const PaymentMethodListComponent = loadable(
  () => import("../../../components/Settings/PaymentMethod/PaymentMethodList")
);

const PaymentMethodList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Payment Method</span>
      </div>
      <PaymentMethodListComponent />
    </>
  );
};



export default PaymentMethodList
